import Axios from 'axios';
import ApiConfig from './apiConfig'
import Auth from '../mixins/auth';
import Router from '../router/index';

let config = {
  baseURL: ApiConfig.baseURL
};

const axios = Axios.create(config);

axios.interceptors.response.use(response => {
  if (response.data === "")
    response.data = null;

  return Promise.resolve(response);
}, error => {
  if (window.location.href.indexOf('auth') < 0) {
    if (error.response && error.response.status === 401) {
      Router.push({name: 'Forbidden', query: { returnUrl:  window.location.href, status: error.response.status }});
    } else if (error.response && error.response.status === 403) {
      //Router.push({path: '/forbidden', query: { returnUrl:  window.location.href, status: error.response.status }});
    }
    return Promise.reject(error);
  }
});

axios.interceptors.request.use(request => {
  request.headers.authorization = "Bearer " + Auth.getToken();
  return request;
}, error => {
  return Promise.reject(error);
});
export default axios;
